import React from "react";
import RegistrationCard from "../RegistrationCard";
import { Button, CardActions, CardText } from "react-md";

const QuestionnairePage = ({ match, questionnaire, questions, onSubmit }) => {
  const index = match.params.index ? match.params.index : 0;
  const question = questions ? questions[index] : null;

  const answer = (index, answer) => {
    let questionnaireAnswer = {
      [`questionnaire/${index}`]: {
        ...question,
        answer
      }
    };

    const nextIndex = parseInt(index, 10) + 1;

    if (nextIndex < questions.length) {
      questionnaireAnswer.nextStep = `questionnaire/${nextIndex}`;
    }

    onSubmit(questionnaireAnswer);
  };

  return (
    <RegistrationCard
      title="Questionnaire"
      subtitle="Please answer the following questions."
    >
      {question &&
        <div>
          <CardText>
            <div className="md-grid">
              <h2
                style={{ textAlign: "center" }}
                className="md-cell md-cell--12 md-display-1"
              >
                {question.text}
              </h2>
            </div>

            <h3 style={{ textAlign: "center" }}>
              {parseInt(index, 10) + 1} of {questions.length}
            </h3>
          </CardText>
          <CardActions>
            <Button
              raised
              label="Yes"
              primary
              className="md-cell--left"
              onClick={() => answer(index, true)}
            />
            <Button
              raised
              label="No"
              secondary
              className="md-cell--right"
              onClick={() => answer(index, false)}
            />
          </CardActions>
        </div>}

    </RegistrationCard>
  );
};

QuestionnairePage.propTypes = {};
QuestionnairePage.defaultProps = {};

export default QuestionnairePage;



// WEBPACK FOOTER //
// ./src/registration/components/Questionnaire/QuestionnairePage.jsx